define('TescoMobile_Catalog/js/view/deal-tariff',['uiComponent', '../model/deal', 'underscore', 'jquery', 'mage/translate', 'Magento_Catalog/js/price-utils', 'mage/cookies'], function (Component, deal, _, $, $t, utils) {
  'use strict';

  return Component.extend({
    defaults: {
      optionMap: {},
      contractType: "",
      productSku: "",
      dynamicPricesEnabled: false,
      selectedTariff: null,
      imports: {
        deviceMonthlyPrice: "tm-cca-price:deviceMonthlyPrice"
      }
    },
    initialize: function () {
      this._super();
      this._setupTariffChangeEvent();
      this._radioButtonOptionsUpdater();
      this.selectedTariff.subscribe(this.updateDynamicPrice, this);
      this.deviceMonthlyPrice.subscribe(this.updateDynamicPrice, this);
      return this;
    },
    initObservable: function () {
      this._super().observe(['selectedTariff', 'deviceMonthlyPrice']);
      return this;
    },
    _setupTariffChangeEvent: function () {
      var tariffOptionRadioSelector,
        _self = this;
      if (this.optionMap.tariff.option_id) {
        tariffOptionRadioSelector = this.getTariffOptionSelector();
      }
      const tariffSwatch = $(tariffOptionRadioSelector + ':checked');
      const tariffSwatches = $(tariffOptionRadioSelector);
      this._showDataPlans(tariffSwatch);
      this._setDynamicPrice(tariffSwatch);
      if (tariffSwatch.length > 0) {
        this._setTariffData(tariffSwatch.val());
      } else {
        this._setTariffData(this.optionMap.tariff.options[0].selection_id);
      }
      if (tariffSwatches.length) {
        tariffSwatches.on('change', $.proxy(function (event) {
          let selectedId = $(event.target);
          if (selectedId) {
            deal.selectedTariffSku = this._getSkuBySelectionId(selectedId.val());
            this._setTariffData(selectedId.val());
            _self._showDataPlans(selectedId);
            _self._setDynamicPrice(selectedId);
            deal.tariffSelectionValue = selectedId.val();
          }
          $(document).trigger('afterTariffUpdate');
        }, this));
      }
      $(document).trigger('afterTariffUpdate');
    },
    _getSkuBySelectionId(selectionId) {
      var tariffSelection = _.findWhere(this.optionMap.tariff.options, {
        selection_id: selectionId
      });
      return tariffSelection.sku;
    },
    _setTariffData(selectionId) {
      var tariffSelectionData = _.findWhere(this.optionMap.tariff.options, {
        selection_id: selectionId
      });
      deal.tariffSelectionData = tariffSelectionData;
      this.selectedTariff(tariffSelectionData);
      $(document).trigger('afterTariffUpdate');
    },
    _getTariffOptionDataBySelectionId(selectionId, dataKey) {
      if (typeof selectionId === 'undefined') {
        return selectionId;
      }
      var tariffSelection = _.findWhere(this.optionMap.tariff.options, {
        selection_id: selectionId
      });
      return tariffSelection[dataKey];
    },
    _showDataPlans: function (selector) {
      let radioValue = selector.val();
      let dataPlanItems = [];
      let allowanceMinutes = this._getTariffOptionDataBySelectionId(radioValue, 'allowance_minutes');
      if (allowanceMinutes !== '' && typeof allowanceMinutes !== 'undefined' && allowanceMinutes !== null) {
        dataPlanItems.push($('<div />', {
          class: 'data-plan data-plan__minutes',
          append: ['<span class="icon icon-comments"></span>' + allowanceMinutes]
        }));
      }
      if (parseInt(this.isAssisted) !== 1) {
        let allowanceSms = this._getTariffOptionDataBySelectionId(radioValue, 'allowance_sms');
        if (allowanceSms !== '' && typeof allowanceSms !== 'undefined') {
          dataPlanItems.push($('<div />', {
            class: 'data-plan data-plan__sms',
            append: [allowanceSms]
          }));
        }
        if (dataPlanItems.length > 0) {
          let datePlansTitle = $('<div />', {
            class: 'data-plan__title',
            append: ['<span>' + $t('All our tariffs come with ') + '</span>']
          });
          dataPlanItems.unshift(datePlansTitle);
        }
        let datePlansWrapper = $('<div />', {
          class: 'data-plan-wrapper',
          append: dataPlanItems
        });
        $('.data-plan-wrapper').remove();
        $(selector).parents('.field.option').append(datePlansWrapper);
      }
    },
    _priceFormat: function (price) {
      return utils.formatPrice(price);
    },
    _priceDiff: function (x, y) {
      return Math.round(x * 100) > Math.round(y * 100) ? '-' + this._priceFormat(x - y) : '+' + this._priceFormat(y - x);
    },
    _setDynamicPrice: function (selection) {
      let radioValue = selection.val(),
        currentPrice = this._getTariffOptionDataBySelectionId(radioValue, 'price');
      _.each($(this.getTariffOptionSelector()), function (radioItem) {
        this.setDynamicPriceForItem(radioItem, currentPrice);
      }.bind(this));
    },
    setDynamicPriceForItem: function (item, currentPrice) {
      var _this$deviceMonthlyPr;
      const selectionId = item.value,
        price = this._getTariffOptionDataBySelectionId(selectionId, 'price') + ((_this$deviceMonthlyPr = this.deviceMonthlyPrice()) !== null && _this$deviceMonthlyPr !== void 0 ? _this$deviceMonthlyPr : 0),
        radioIdLabelPrice = 'label[for="' + item.id + '"] .price',
        radioIdLabelPricePost = `<span>${$t('a month')}</span>`,
        radioIdLabelPriceWrapper = `<div class="regular-price-wrapper">${this._priceFormat(price)} ${radioIdLabelPricePost}</div>`;
      if (this.dynamicPricesEnabled) {
        if (price == currentPrice) {
          $(radioIdLabelPrice).html(radioIdLabelPriceWrapper);
        } else {
          let diffPrice = this._priceDiff(currentPrice, price);
          $(radioIdLabelPrice).html(diffPrice);
        }
      } else {
        $(radioIdLabelPrice).html(radioIdLabelPriceWrapper);
      }
    },
    _radioButtonOptionsUpdater: function () {
      const _self = this;
      if (this.optionMap.tariff.option_id) {
        const tariffOptionRadioSelector = this.getTariffOptionSelector();
        if (_self.contractType.indexOf('BAU') !== -1) {
          $(tariffOptionRadioSelector).parent().parent().addClass('contract-type-bau');
        }
        _.each(this.optionMap.tariff.options, function (option) {
          _.each($(tariffOptionRadioSelector), function (radioItem) {
            if (option.selection_id == radioItem.value) {
              _self._nudgeTooltip(option, radioItem);
              _self._dataAllowance(option, radioItem);
            }
          });
        });
      }
    },
    _dataAllowance: function (option, radioItem) {
      if (option.allowance_data !== null) {
        let radioIdLabelAllowance = 'label[for="' + radioItem.id + '"] .allowance';
        $(radioIdLabelAllowance).html(option.allowance_data + '<span>' + $t('data ') + '</span>');
      }
    },
    _dataMinutes: function (option, radioItem) {
      if (option.allowance_minutes !== null) {
        let radioIdLabelAllowance = 'label[for="' + radioItem.id + '"]';
        let minutesDom = $('<div />', {
          class: 'data-minutes',
          append: option.allowance_minutes
        });
        $(radioIdLabelAllowance).append(minutesDom);
      }
    },
    _nudgeTooltip: function (option, radioItem) {
      var _self = this;
      if (option.nudge != null) {
        if ($.mage.cookies.get('hideNudge' + _self.productSku) !== '1') {
          let nudgeTooltipContent = $('<div></div>', {
            class: 'tooltip-content',
            append: '<span class="icon icon-close"></span>' + [option.nudge]
          });
          let radioId = '#' + radioItem.id;
          $(radioId).parent().addClass('tariff-nudge-tooltip');
          $(radioId).next().addClass('tooltip-toggle');
          $(radioId).parent().append(nudgeTooltipContent);
          var date = new Date();
          date.setTime(date.getTime() + 3600 * 1000);
          $(".tooltip-content span").on('click', function () {
            $(this).parent().hide();
            $.mage.cookies.get('hideNudge' + _self.productSku, 1, {
              expires: date
            });
          });
        }
      }
    },
    _getUrlParam: function (type) {
      var getParams = window.location.search;
      if (getParams !== '') {
        var searchParams = new URLSearchParams(getParams.slice(1));
        return searchParams.get(type) ? searchParams.get(type) : false;
      }
      return false;
    },
    getTariffOptionSelector: function () {
      return 'input[name="bundle_option[' + this.optionMap.tariff.option_id + ']"]';
    },
    updateDynamicPrice: function () {
      this._setDynamicPrice($(`${this.getTariffOptionSelector()}:checked`));
    }
  });
});

